export const BANNER_A = 'bannerA';
export const BANNER_B = 'bannerB';
export const BANNER_COOKIE = 'test';
export const EXPIRED_TIME = 60 * 60000 * 24; // 1 day in milliseconds
export const BANNER_DD_KEY = 'tests';
